define('shoptheme/components/ui/sections',[
	"jquery",
	"cartware/components/_base",
	"bootstrap-tooltip"
], function(
	$,
	Component
) {
	return Component.create({
		$init: function() {
			this.scrollToSection(document.location.href);

			var self = this;

			$('a[href*=\\#c]').on('click', function (event) {
				self.scrollToSection(event.currentTarget.href);
			});
		},

		scrollToSection: function (href) {
			var regex = /.*#c(.*)/,
				matches = regex.exec(href);

			if (matches) {
				var element = $('[data-section-id="' + matches[1] +'"]');

				if (element.length > 0) {
					var target = element[0];

					$([document.documentElement, document.body]).animate({
						scrollTop: $(target).offset().top
					}, 500);
				}
			}
		}
	});
});
